<!-- AM-4734: `tailwind` swaps the criteria-bar register for the design system's. The classes below
     mirror `lh-shared-ui-input`'s tailwind branch so the two read as one control family — with one
     deliberate difference: the orange focus uses `focus-within:` because the focus lands on the
     inner <input>, not on this container. -->
<div
  id="placesSearchContainer"
  class="dropdown"
  [ngClass]="
    tailwind
      ? [
          'tw-relative tw-flex tw-gap-2 tw-w-full tw-bg-white tw-font-normal',
          'tw-p-2 tw-border tw-border-solid tw-border-neutral-300',
          'focus-within:tw-border-orange',
          'tw-text-sm tw-text-neutral-950 tw-rounded-md'
        ]
      : ['places-search-container']
  "
  [class.typing]="typing"
  [class.form-control]="formControlMode && !tailwind"
  #placesDropdown="bs-dropdown"
  dropdown
  [autoClose]="true"
  [insideClick]="true"
  >
  <!-- The criteria-bar stylesheet paints the magnifier as a background-image on the class the
       tailwind register turns off, so without this the field would lose its icon and stop matching
       the `lh-shared-ui-input` it is meant to sit beside — which is the whole point of the flag.
       Decorative: the field is named by its own aria-label, so this must not be announced.
       Note for the next app that opts into `tailwind` — `lhSearchIcon` is currently provided only by
       the dashboard app, so register it there too or this renders an empty box. -->
  @if (tailwind) {
    <lh-shared-ui-svg-icon [key]="'search'" aria-hidden="true" />
  }
  <input
    id="searchInput"
    name="searchInput"
    #searchInput
    type="text"
    autocomplete="off"
    [value]="displayValue"
    [ngClass]="
      tailwind
        ? [
            'tw-flex-1 tw-min-w-0 tw-border-none tw-bg-transparent tw-outline-none',
            'focus:tw-outline-none focus-visible:tw-outline-none tw-ring-0 focus:tw-ring-0',
            'tw-shadow-none tw-appearance-none placeholder:tw-text-neutral-400'
          ]
        : ['form-control', 'places-search-field', formControlMode ? '' : 'standalone']
    "
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    [(ngModel)]="query"
    [disabled]="disabled"
    (keypress)="onSearchFieldKeyPress($event)"
    (input)="onQueryChanged()"
    (focus)="selectAllText()"
    [attr.aria-label]="ariaLabel || null"
    [placeholder]="placeholder || ('WHERE' | lhTranslate) + '?'"
    />

  <ul class="dropdown-menu" *dropdownMenu role="menu" aria-labelledby="place-predictions">
    @for (prediction of predictions; track prediction) {
      <li class="prediction-item href">
        <a (click)="selectPlace(prediction)" class="prediction-item-button">
          <span class="prediction-item-title">{{ getMainText(prediction) }}</span>
          <span class="prediction-item-subtitle">{{ getSecondaryText(prediction) }}</span>
        </a>
      </li>
    }
  </ul>
</div>
